import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const FinalCTA = () => (
  <section className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-[#2563eb] px-6 py-20 text-center text-white shadow-[0_40px_80px_-30px_rgba(37,99,235,0.6)] sm:px-12 sm:py-28">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_circle_at_50%_130%,rgba(255,255,255,0.22),transparent_75%)]" />
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#60a5fa]/40 blur-3xl" />
          <div className="relative mx-auto max-w-4xl">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-100">04 // The Horizon</p>
            <h2 className="font-display mt-8 text-4xl font-bold leading-[1.08] sm:text-5xl lg:text-6xl">
              Stop drafting tickets.
              <span className="block text-blue-100">Start shipping reality.</span>
            </h2>
            <div className="mt-12 flex flex-col items-center gap-6">
              <a
                data-testid="final-cta-button"
                href="https://emergent.sh"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 rounded-full bg-white px-9 py-4 text-sm font-semibold text-[#2563eb] shadow-[0_12px_32px_-8px_rgba(0,0,0,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f8f8f6] sm:px-10 sm:py-5 sm:text-base"
              >
                Build your app now — free
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-blue-100">
                No credit card required · Deploy in 3 minutes
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
